import { useMemo } from "react";
import { useTranslation } from "./useTranslation";


export const useUnits = () => {
  const { t } = useTranslation();
  return useMemo(() => {
    return [
      { id: 0, title: t("units.price") },
      { id: 1, title: t("units.thing") },
      { id: 2, title: t("units.unit") },
      { id: 3, title: t("units.ball") },
      { id: 4, title: t("units.ounce") },
      { id: 5, title: t("units.lb") },
      { id: 6, title: t("units.stone") },
      { id: 7, title: t("units.gram") },
      { id: 8, title: t("units.kilogram") },
      { id: 9, title: t("units.ton") },
      { id: 10, title: t("units.inch") },
      { id: 11, title: t("units.foot") },
      { id: 12, title: t("units.mile") },
      { id: 13, title: t("units.kilometer") },
      { id: 14, title: t("units.centimeter") },
      { id: 15, title: t("units.millimeter") },
      { id: 16, title: t("units.gallon") },
      { id: 17, title: t("units.milliliter") },
      { id: 18, title: t("units.liter") },
      { id: 19, title: t("units.second") },
      { id: 20, title: t("units.minute") },
      { id: 21, title: t("units.hour") },
      { id: 22, title: t("units.day") },
      { id: 23, title: t("units.month") },
      { id: 24, title: t("units.year") },
      { id: 25, title: t("units.squareInch") },
      { id: 26, title: t("units.squareFoot") },
      { id: 27, title: t("units.squareCentimeter") },
      { id: 28, title: t("units.squareMeter") },
    ];
  }, [t]);
};
